/* eslint-disable @typescript-eslint/no-unnecessary-condition -- temporary config solution */
import { normalizeSlashChars } from '@ori/checkout-utils';
import { parseClientAppConfig } from '@ori/client-app-config';
import { logDebug } from '../logger';
import { parseOldAddressFormat } from './parseOldAddressFormat';

/**
 * Normalizes some values in the raw parsed config.
 * @param parsedConfig Original config data returned by the parseSpaConfig method.
 * @returns Final normalized configuration.
 */
export const normalizeConfigData = parsedConfig => {
  // Temporary solution for local Online development (localApiUrl has value only if Online environment is local)
  const globalApiUrl = parsedConfig.localApiUrl ? parsedConfig.localApiUrl : parsedConfig.globalApiUrl;
  const originalAddressFormat = parsedConfig.addressFormat;
  const addressFormat = typeof originalAddressFormat === 'string' ? parseOldAddressFormat(originalAddressFormat) : originalAddressFormat;
  const result = {
    ...parsedConfig,
    addressFormat,
    customerOrdersLink: normalizeSlashChars(parsedConfig.customerOrdersLink ?? '', true, false),
    globalApiUrl: normalizeSlashChars(globalApiUrl, false, false),
    identityUrl: normalizeSlashChars(parsedConfig.identityUrl, false, false),
    manageSubscriptionLink: normalizeSlashChars(parsedConfig.manageSubscriptionLink ?? '', true, false),
    rewardsShopLink: normalizeSlashChars(parsedConfig.rewardsShopLink ?? '', true, false),
    staticApiUrl: normalizeSlashChars(parsedConfig.staticApiUrl, false, false)
  };
  return result;
};

/**
 * Parses the configuration for simplified checkout SPA component.
 * @param config Simplified checkout SPA root element.
 * @returns Simplified checkout component configuration.
 */
export const getConfiguration = config => {
  const parsedConfig = parseClientAppConfig(config, ['currentLanguage', 'defaultQty', 'globalApiUrl', 'graphqlNetUrl', 'identityUrl', 'isDoubleCurrency', 'isQofVisible', 'maxValue', 'minValue', 'periodId', 'staticApiUrl', 'tenant']);
  logDebug('parsed configuration', parsedConfig);
  return normalizeConfigData(parsedConfig);
};